import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var MenuIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 24 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsx(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M15.95 2.667a.75.75 0 0 1-.75.751l-14.4.01a.75.75 0 1 1 0-1.5l14.4-.01a.75.75 0 0 1 .75.75ZM.8 7.255l14.4-.01a.75.75 0 1 1 0 1.5l-14.4.01a.75.75 0 1 1 0-1.5Zm0 5.327 14.4-.01a.75.75 0 0 1 0 1.5l-14.4.01a.75.75 0 1 1 0-1.5Z",
            clipRule: "evenodd"
        }) : /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M0 4a.75.75 0 0 1 .75-.75h22.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4ZM0 12a.75.75 0 0 1 .75-.75h22.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 12ZM.75 19.25a.75.75 0 0 0 0 1.5h22.5a.75.75 0 0 0 0-1.5H.75Z"
        })
    }));
};
